import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiActivity } from "react-icons/fi";
import { MdEco } from "react-icons/md";
import { Modal, useTheme } from "@mui/material";
import { useViewport } from "../../hooks/useViewport";
import "./index.css";
import { useAppSelector } from "../../hooks";
import { getProticoClient } from "../../utils/api";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { postEngagementEvent } from "../../utils/api/voucher";

const StaleModal = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { handleUserReActivity, isStale } = useViewport();
  const { adList } = useAppSelector((state) => state.whiteboard);
  const { roomUrl, roomDomain } = useWhiteboardRoom();

  const handleAdsClick = () => {
    postEngagementEvent("daily_ad_click", roomDomain);
    handleAdClickEvent();
    window.open(adList[0]?.ads_url, "_blank");
  };
  const handleAdShowEvent = () => {
    getProticoClient().engagement.recordAdsEvent({
      url: roomUrl,
      ad_data: {
        ad_id: adList[0]?.id.toString(),
        ad_title: adList[0]?.ads_title,
        ad_resource_url: adList[0]?.ads_url,
        engagement_type: "show",
        content_type: "image",
        position_type: "bubble",
        recommand_type: adList[0]?.recommand_type,
      },
    });
  };
  const handleAdClickEvent = () => {
    getProticoClient().engagement.recordAdsEvent({
      url: roomUrl,
      ad_data: {
        ad_id: adList[0]?.id.toString(),
        ad_title: adList[0]?.ads_title,
        ad_resource_url: adList[0]?.ads_url,
        engagement_type: "click",
        content_type: "image",
        position_type: "bubble",
        recommand_type: adList[0]?.recommand_type,
      },
    });
  };
  useEffect(() => {
    if (isStale && adList.length > 0) {
      handleAdShowEvent()
    }
  }, [isStale]);
  return (
    <Modal open={true} className="stale-modal-container">
      <>
        <div className="stale-modal-title">
          <MdEco className="stale-modal-title-icon" />
          {t("Stale_Modal_Title")}
        </div>
        <div className="stale-modal-desc">{t("Stale_Modal_Desc")}</div>
        <button
          className="stale-modal-button-start"
          onClick={handleUserReActivity}
          style={{
            backgroundColor: theme.brandColor,
          }}
        >
          {t("Stale_Modal_Btn")}
          <FiActivity className="stale-modal-button-icon" />
        </button>
        {adList.length > 0 && (
          <>
            <div
              style={{ color: "#a0a0a0", fontSize: "0.85em", padding: "5px" }}
            >
              Sponsored AD
            </div>
            <div style={{ height: "160px", overflow: "hidden" }}>
              <img
                style={{ cursor: "pointer", width: "240px" }}
                src={
                  adList[Math.floor(Math.random() * adList.length)]?.image_url
                }
                onClick={handleAdsClick}
              />
            </div>
          </>
        )}
      </>
    </Modal>
  );
};

export default StaleModal;
